import {Money} from "../../../../../lib/Money.ts";
import {TransactionWithMatchMetadata, BillWithMatchMetadata} from "./types.ts";
import type {DocumentDirection} from "../../../../../generated/enums.ts";
import type {CurrencyEnum} from "../../../../../generated/enums.ts";
export type Transaction = TransactionWithMatchMetadata;
export type Document = BillWithMatchMetadata;

export interface AttachedItem {
    id: string;
    kind: 'transaction' | 'bill';
    bill_id?: string;
    relation_name: string;
    amount: Money;
    metadata?: string;
    date?: string;
    document_category?: string;
    document_direction?: DocumentDirection | null;
    nrs_amount?: number | null;
}

export type MatchStatus = "pending" | "accepted" | "rejected";

export const LIST_IDS = {
    TRANSACTIONS: "transactions-list",
    DOCUMENTS: "documents-list",
} as const;

export const DEFAULT_CURRENCY: CurrencyEnum = "EUR";

export interface MatchAcceptData {
    currentItemId: string;
    matchedItemIds: string[];
    billIds: string[];
    transactionIds: string[];
    targetMatchId?: string;
}